import React, { FC, PropsWithChildren } from 'react';

import { SentryErrorBoundary } from 'app/packages/components/Sentry';

import styles from './ErrorBoundary.module.scss';

export type ErrorBoundaryProps = {
  fallbackText: string;
};

export const ErrorBoundary: FC<PropsWithChildren<ErrorBoundaryProps>> = ({
  fallbackText,
  children,
}) => {
  const errorText = <p className={styles.errorText}>{fallbackText}</p>;

  return (
    <SentryErrorBoundary fallbackText={errorText}>
      {children}
    </SentryErrorBoundary>
  );
};
